/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VitalScoreStrictHttpResponse } from '../../vital-score-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HealthScoreResponseModel } from '../../models/health-score-response-model';

export interface ProfileHealthScoreGet$Params {
}

export function profileHealthScoreGet(http: HttpClient, rootUrl: string, params?: ProfileHealthScoreGet$Params, context?: HttpContext): Observable<VitalScoreStrictHttpResponse<HealthScoreResponseModel>> {
  const rb = new RequestBuilder(rootUrl, profileHealthScoreGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as VitalScoreStrictHttpResponse<HealthScoreResponseModel>;
    })
  );
}

profileHealthScoreGet.PATH = '/Profile/HealthScore';
